$ ->
  $('.cw_richtext').summernote
    tooltip: false
